import { useMutation } from "@apollo/client";
import { Button, Card, Checkbox, Drawer, message } from "antd";
import React, { useState } from "react";
import { ASSIGN_TASK } from "../../../Graphql/mutations";

import "./AssignRequiredAttachment.css";

const AssignRequiredAttachment = ({
  user_id,
  requiredAttachmentList,
  showRequiredAttachmentDrawer,
  setShowRequiredAttachmentDrawer,
  checkedRequiredAttechTaskList,
  setCheckedRequiredAttechTaskList,
  selectedCustomTaskList,
}) => {
  const [UPDATE_ASSIGNED_TASKS_MUTATION, { loading: isAssigningTask }] =
    useMutation(ASSIGN_TASK);
  const onCloseRequiredAttachmentDrawer = () => {
    setShowRequiredAttachmentDrawer(false);
  };
  const onRequiredAttechTaskSelect = (taskId) => {
    setCheckedRequiredAttechTaskList(taskId);
  };
  const onContinueAssignTask = async () => {
    let assignTaskData = [
      ...JSON.parse(JSON.stringify(requiredAttachmentList)),
      ...JSON.parse(JSON.stringify(selectedCustomTaskList)),
    ];
    const taskSet = assignTaskData.flatMap((task) => {
      delete task.description;
      return ({...task, required_attachment: checkedRequiredAttechTaskList.includes(task.task_id),});
    });
    try {
      const response = await UPDATE_ASSIGNED_TASKS_MUTATION({
        variables: {
          tasks: taskSet,
          user_id: user_id,
        },
      });
      if (response?.data?.assign_task?.status === "OK") {
        message.success(response.data.assign_task?.message);
        setShowRequiredAttachmentDrawer(false);
      } else {
        message.error(response.errors[0].message);
      }
    } catch (error) {
    }
  };
  return (
    <Drawer
      placement="right"
      closable={false}
      width={720}
      maskStyle={{ backgroundColor: "#000000CC" }}
      title="Check all the tasks which require a proof of completion (for e.g a picture) at the time of completing the task by the employee."
      // onClose={onCloseRequiredAttachment}
      // visible={showRequiredAttachment}
      onClose={onCloseRequiredAttachmentDrawer}
      visible={showRequiredAttachmentDrawer}
    >
      <div className="d-flex p-3 flex-column ">
        <div className="taskRequiredAttachment">
          <Checkbox.Group
            value={checkedRequiredAttechTaskList}
            onChange={onRequiredAttechTaskSelect}
          >
            {requiredAttachmentList.map((task, index) => {
              return (
                <Card key={index} className="mb-2 requiredAttachmentList">
                  <div className="d-flex">
                    <div className="ml-auto"><div className={`tagStatus ${task.task_type}`}>{task.type_name}</div></div>
                  </div>
                  <Checkbox key={index} value={task.task_id}>
                    {task.description}
                  </Checkbox>
                </Card>
              );
            })}
          </Checkbox.Group>
          <div className="taskRequiredAttachmentAction p-4 text-center">
            <Button
              type="default"
              shape="round"
              size="large"
              className="h-auto"
              onClick={onCloseRequiredAttachmentDrawer}
            >
              Cancel
            </Button>
            <Button
              type="primary"
              shape="round"
              size="large"
              className="h-auto ml-3"
              loading={isAssigningTask}
              onClick={onContinueAssignTask}
            >
              Assign
            </Button>
          </div>
        </div>
      </div>
    </Drawer>
  );
};

export default AssignRequiredAttachment;
